import React, { useState } from "react";
import { NoEmployees } from "../../employees/components/NoEmployees";
import { TableActiveDateRange } from "../../common/components/TableDateRange";
import { LinkEmployee } from "../../employees/Routes";
import { useQueryWithPagination } from "../../utils/Hooks";
import { AxiosEmployeePositionAPI } from "../../common/Api";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { PaginationButtons } from "../../common/components/PaginationButtons";

const PositionEmployeeTable = ({
  employeeposition_set,
  ordering,
  setOrdering,
}) => {
  if (employeeposition_set.length === 0) {
    return <NoEmployees message="Não há funcionários ativos com este cargo!" />;
  }

  const rows = employeeposition_set.map((el) => ({
    id: el.id,
    name: <LinkEmployee employee={el.employee} />,
    startDate: el.timespan.lower,
  }));

  return (
    <TableActiveDateRange
      recordName={"Funcionário"}
      data={rows}
      ordering={ordering}
      setOrdering={setOrdering}
      nameColumn="employee"
    />
  );
};

export const PositionEmployeeList = ({ position_id }) => {
  const [ordering, setOrdering] = useState(null);

  const { isPending, data, error, handleNext, handlePrevious } =
    useQueryWithPagination({
      queryKey: ["position-employee-list", position_id, ordering],
      queryFn: AxiosEmployeePositionAPI.getForPosition,
      position_id: position_id,
      ordering: ordering,
    });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;
  if (data) {
    return (
      <>
        <PositionEmployeeTable
          employeeposition_set={data.results}
          ordering={ordering}
          setOrdering={setOrdering}
        />
        <PaginationButtons
          previous={data?.previous}
          next={data?.next}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      </>
    );
  }

  return null;
};
